import Enums from "../../../../enums/enums";
import Helper from "../../../../helper/merchantHelper";
const state = {
  merchantTemplate: Helper.GetMerchantTemplateDefault(),
  merchantId: 0,
  insertMerchantLoadingStatus: Enums.LoadingStatusType.None,
  searchedMerchantAddressLoadingStatus: Enums.LoadingStatusType.None,
  activePayrollLoadingStatus: Enums.LoadingStatusType.None,
  inputSearchedMerchantAddress: null,
  searchedMerchantAddressType: null,
  insertSampleMerchantLoadingStatus: Enums.LoadingStatusType.None,
  sampleMerchantId: 0,
  onBoardingMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  onBoardingMerchantSample: null,
  createContactMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createBankAccountMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createProductMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createAllocationMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createQrCodeMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createInvoiceMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createInvoiceWithReceiptMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createReceiptMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createExpenseMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createExpenseLazadaSetBefore2MonthMerchantSampleStatus: Enums.LoadingStatusType.None,
  createExpenseLazadaSet2MonthMerchantSampleStatus: Enums.LoadingStatusType.None,
  createJournalMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  createCustomDashBoardMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  updateStatusMerchantSampleLoadingStatus: Enums.LoadingStatusType.None,
  captureTrialBalanceByMerchantLoadingStatus: Enums.LoadingStatusType.None,
  suggestCreateMerchantMobile: false,
};

const getters = {
  GetMerchantTemplate: (state) => {
    return state.merchantTemplate;
  },
  GetInsertMerchantLoadingStatus: (state) => {
    return state.insertMerchantLoadingStatus;
  },
  GetInputSearchedMerchantAddress: (state) => {
    return state.inputSearchedMerchantAddress;
  },
  GetSearchedMerchantAddressType: (state) => {
    return state.searchedMerchantAddressType;
  },
  GetMerchantIdByInsertMerchant: (state) => {
    return state.merchantId;
  },
  GetSearchedMerchantAddressLoadingStatus: (state) => {
    return state.searchedMerchantAddressLoadingStatus;
  },
  GetInsertSampleMerchantLoadingStatus: (state) => {
    return state.insertSampleMerchantLoadingStatus;
  },
  GetSampleMerchantId: (state) => {
    return state.sampleMerchantId;
  },
  GetOnBoardingMerchantSampleLoadingStatus: (state) => {
    return state.onBoardingMerchantSampleLoadingStatus;
  },
  GetOnBoardingMerchantSample: (state) => {
    return state.onBoardingMerchantSample;
  },
  GetCreateContactMerchantSampleLoadingStatus: (state) => {
    return state.createContactMerchantSampleLoadingStatus;
  },
  GetCreateBankAccountMerchantSampleLoadingStatus: (state) => {
    return state.createBankAccountMerchantSampleLoadingStatus;
  },
  GetCreateProductMerchantSampleLoadingStatus: (state) => {
    return state.createProductMerchantSampleLoadingStatus;
  },
  GetCreateAllocationMerchantSampleLoadingStatus: (state) => {
    return state.createAllocationMerchantSampleLoadingStatus;
  },
  GetCreateQrCodeMerchantSampleLoadingStatus: (state) => {
    return state.createQrCodeMerchantSampleLoadingStatus;
  },
  GetCreateInvoiceMerchantSampleLoadingStatus: (state) => {
    return state.createInvoiceMerchantSampleLoadingStatus;
  },
  GetCreateInvoiceWithReceiptMerchantSampleLoadingStatus: (state) => {
    return state.createInvoiceWithReceiptMerchantSampleLoadingStatus;
  },
  GetCreateReceiptMerchantSampleLoadingStatus: (state) => {
    return state.createReceiptMerchantSampleLoadingStatus;
  },
  GetCreateExpenseMerchantSampleLoadingStatus: (state) => {
    return state.createExpenseMerchantSampleLoadingStatus;
  },
  GetCreateExpenseLazadaSetBefore2MonthMerchantSampleStatus: (state) => {
    return state.createExpenseLazadaSetBefore2MonthMerchantSampleStatus;
  },
  GetCreateExpenseLazadaSet2MonthMerchantSampleStatus: (state) => {
    return state.createExpenseLazadaSet2MonthMerchantSampleStatus;
  },
  GetCreateJournalMerchantSampleLoadingStatus: (state) => {
    return state.createJournalMerchantSampleLoadingStatus;
  },
  GetCreateCustomDashBoardMerchantSampleLoadingStatus: (state) => {
    return state.createCustomDashBoardMerchantSampleLoadingStatus;
  },
  GetUpdateStatusMerchantSampleLoadingStatus: (state) => {
    return state.updateStatusMerchantSampleLoadingStatus;
  },
  GetUpdateStatusMerchantSampleLoadingStatus: (state) => {
    return state.updateStatusMerchantSampleLoadingStatus;
  },
  GetCaptureTrialBalanceByMerchantLoadingStatus: (state) => {
    return state.captureTrialBalanceByMerchantLoadingStatus;
  },
  GetSuggestCreateMerchantMobile: (state) => {
    return state.suggestCreateMerchantMobile;
  },
};
export { getters, state };

